import { styled } from "@mui/material";

export const Div = styled("div", {
    name: "MuiDiv",
    shouldForwardProp: (_) => true,
    overridesResolver: (props, styles) => {
      return [styles.root];
    },
    skipVariantsResolver: false,
  })({});